import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from '../../../../models/utilities/filter-bar';
import { ListColumn, SelectedSort } from '../../../../models/utilities/list-header';
import { PageData } from '../../../../models/utilities/paged-request';
import { ApiEndpoints, GlobalConstants } from '../../../../utils/app-constants';
import { AppUtils } from '../../../../utils/app-utils';
import { TemplateTypeMetadata } from '../enums/_index';

export class CommunicationSearchFilters implements IFilterBar {

    public paginationInfo   : PageData = new PageData(GlobalConstants.DEFAULT_PAGE_SIZE);
    public baseUrl          : string = ApiEndpoints.COMMUNICATION_MESSAGE_QUERY;
    public filters          : FilterGroup[] = [];
    public appliedFilters   : AppliedFilterBarOpt[] = [];
    public requiredFilters  : AppliedFilterBarOpt[] = [];
    public columns          : ListColumn[];
    public selectedSort     : SelectedSort;
    
    constructor() {

        // Set our table columns
        this.columns = [
            new ListColumn('Date', ''),
            new ListColumn('Status', ''),
            new ListColumn('Type', ''),
            new ListColumn('Template', ''),
            new ListColumn('Shipment', ''),
            new ListColumn('Destination', ''),
            new ListColumn('Dealer', ''),
            new ListColumn('Action', '')
        ];

        // Create our Filter Groups
        const byDealer      = this.buildDealer();
        const byDate        = this.buildCreateDate();
        const byDestination = this.buildDestination();
        const byTemplate    = this.buildTemplate();
        
        this.filters.push(
            byDealer, byDate, byDestination, byTemplate
        );

    }

    // #region Group Builders

    private buildCreateDate() {
        const byDate = new FilterGroup('Created On', 'date', 'date');        
        const opt1 = new FilterBarInputOpt('Created On Date', undefined);
        
        byDate.opts = [opt1];

        return byDate;
    }

    private buildDealer() {
        const byDealer = new FilterGroup('Dealer', 'dealer', 'dealer');        
        const opt1 = new FilterBarInputOpt('Dealer', '');
        
        byDealer.opts = [opt1];

        return byDealer;
    }

    private buildDestination() {
        const byTruckName = new FilterGroup('Email or Fax', 'text', 'destination');
        const opt1 = new FilterBarInputOpt('Email or Fax', '');
        
        byTruckName.opts = [opt1];

        return byTruckName;
    }
    
    private buildTemplate() {
        const byTemplateType = new FilterGroup('Template', 'checkboxes', 'template');
        byTemplateType.opts = AppUtils.enumMetadataToFilters(TemplateTypeMetadata);

        return byTemplateType;
    }

    // #endregion

}
